import { readStoredAuth } from '../api/authApi';
import { createCrashReport } from '../api/clients/errorReportsClient';
import { diagnosticText, diagnosticUrl } from './diagnosticText';

const CRASH_FINGERPRINT_PREFIX = 'cv.crash.sent.v2:';
const pending = new Map();
const attempts = new Map();
let recent = [];

function buildCrashFingerprint(payload) {
    const digest = String(payload?.error_digest || '');
    const page = typeof window !== 'undefined' ? window.location.pathname.replace(/\/firma-remota\/[^/]+/g, '/firma-remota/[oculto]') : '';
    // Huella corta para deduplicación, no para verificar integridad ni autorizar operaciones.
    let hash = 2166136261;
    for (const char of `${digest}|${page}`) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
    return (hash >>> 0).toString(36);
}

function markCrashAsSent(fingerprint) {
    if (typeof window === 'undefined' || !fingerprint) {
        return;
    }

    try {
        for (const key of Object.keys(window.sessionStorage)) {
            if (key.startsWith('cv.crash.sent:')) window.sessionStorage.removeItem(key);
        }
        const keys = Object.keys(window.sessionStorage).filter(key => key.startsWith(CRASH_FINGERPRINT_PREFIX));
        if (keys.length >= 50) window.sessionStorage.removeItem(keys[0]);
        window.sessionStorage.setItem(`${CRASH_FINGERPRINT_PREFIX}${fingerprint}`, String(Date.now()));
    } catch {
        // Ignorar: no bloquear el flujo por storage.
    }
}

function wasCrashAlreadySent(fingerprint) {
    if (typeof window === 'undefined' || !fingerprint) {
        return false;
    }

    try {
        const at = Number(window.sessionStorage.getItem(`${CRASH_FINGERPRINT_PREFIX}${fingerprint}`) || 0);
        return at > 0 && Date.now() - at < 60000;
    } catch {
        return false;
    }
}

export async function reportCrashToServer(payload) {
    const safePayload = { ...payload, url: payload?.url ? diagnosticUrl(payload.url) : null,
        context: Object.fromEntries(Object.entries(payload?.context || {}).map(([key, value]) => [key, typeof value === 'string' ? diagnosticText(value) : value])),
        error_digest: diagnosticText(payload?.error_digest), report_text: diagnosticText(payload?.report_text) };
    let auth = null;
    try {
        auth = await readStoredAuth();
    } catch {
        auth = null;
    }

    if (!auth?.token || !auth?.user?.id) {
        return;
    }

    const fingerprint = `${auth.user.id}:${buildCrashFingerprint(safePayload)}`;
    if (pending.has(fingerprint)) return pending.get(fingerprint);
    const now = Date.now();
    if (wasCrashAlreadySent(fingerprint) || (attempts.has(fingerprint) && now - attempts.get(fingerprint) < 30000)) return;
    recent = recent.filter(row => now - row.at < 60000);
    if (recent.filter(row => row.userId === auth.user.id).length >= 5) return;
    recent.push({ userId: auth.user.id, at: now });
    if (attempts.size >= 50) attempts.delete(attempts.keys().next().value);
    attempts.set(fingerprint, now);
    const work = Promise.resolve().then(() => createCrashReport(auth.token, safePayload))
        .then(() => markCrashAsSent(fingerprint)).catch(() => { /* No interrumpir la app por el diagnóstico. */ })
        .finally(() => pending.delete(fingerprint));
    pending.set(fingerprint, work);
    return work;
}
